import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import BooksManagement from '../../components/2Speakers/speakerContent/BooksManagement';
import BlogManagement from '../../components/2Speakers/speakerContent/BlogManagement';
import VideosManagement from '../../components/2Speakers/speakerContent/VideosManagement';
import ContributionsManagement from '../../components/2Speakers/speakerContent/ContributionsManagement';

const MyContentManagementTabs = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const [activeTab, setActiveTab] = useState("books");
  
  const renderTabContent = () => {
    switch (activeTab) {
      case 'books':
        return <BooksManagement />;
      case 'blog':
        return <BlogManagement />;
      case 'videos':
        return <VideosManagement />;
      case 'contributions':
        return <ContributionsManagement />;
      default:
        return null;
    }
  };

  return (
    <div dir={languageDirection}>
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1
                className="section-title text-center mb-5"
                data-translate="manage_content"
              >
                {t('manage_content')}
              </h1>

              <ul
                className="nav nav-tabs content-tabs"
                id="contentTabs"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "books" ? "active" : ""}`}
                    onClick={() => setActiveTab("books")}
                    type="button"
                    role="tab"
                    data-translate="books_management"
                  >
                    {t('books_management')}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "blog" ? "active" : ""}`}
                    onClick={() => setActiveTab("blog")}
                    type="button"
                    role="tab"
                    data-translate="blog_management"
                  >
                    {t('blog_management')}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "videos" ? "active" : ""}`}
                    onClick={() => setActiveTab("videos")}
                    type="button"
                    role="tab"
                    data-translate="videos_management"
                  >
                    {t('videos_management')}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "contributions" ? "active" : ""}`}
                    onClick={() => setActiveTab("contributions")}
                    type="button"
                    role="tab"
                    data-translate="contributions_management"
                  >
                    {t('contributions_management')}
                  </button>
                </li>
              </ul>

              <div className="tab-content p-4 bg-white shadow-sm rounded-bottom">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyContentManagementTabs;
